import { useSetAtom } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { setAddress } from "../lib/draft.lib";
import type { ShippingAddress } from "../types";

export function useSetAddress(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));

  return (address: ShippingAddress) => {
    setDraft((draft) => (draft ? setAddress(draft, address) : draft));
  };
}
